import { useRef } from 'react';

/**
 * A ref that always holds the value from the latest render.
 *
 * Use it when a long-lived callback (socket handler, timer, window listener, or a
 * memoized useCallback) must call the CURRENT version of a function or read the
 * current value, without re-registering every render. The returned ref object is
 * stable, so it never needs to be listed in a dependency array.
 *
 * Read it only at call time (inside the callback), never during render.
 */
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
